import { render, staticRenderFns } from "./scorelist.vue?vue&type=template&id=4d58cb31"
import script from "./scorelist.vue?vue&type=script&lang=js"
export * from "./scorelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports